import React, { useState } from 'react';
import useSceneStore from '../store/useSceneStore';
import { getAllStairItems } from '../catalog/stairsCatalog';
import { TOOLS } from '../core/constants';
import SafeIcon from '../common/SafeIcon';
import * as FiIcons from 'react-icons/fi';
import { clsx } from 'clsx';

const { FiTrendingUp } = FiIcons;

const StairsCatalogPanel = () => {
  const { tool } = useSceneStore();
  const [isDragging, setIsDragging] = useState(null);

  // Pobieramy płaską listę wszystkich schodów zamiast kategorii
  const items = getAllStairItems();

  if (tool !== TOOLS.STAIRS) return null;

  const handleDragStart = (e, item) => {
    setIsDragging(item);
    // Ustawiamy dane dla przeciągania - identyfikator elementu
    e.dataTransfer.effectAllowed = 'copy';
    e.dataTransfer.setData('stairItemId', item.id); // Ważne: używamy klucza stairItemId
    
    // Tworzymy niestandardowy obrazek przeciągania
    const dragImage = document.createElement('div');
    dragImage.className = 'p-2 bg-white border-2 border-[#1E2937] rounded-lg shadow-lg';
    dragImage.innerHTML = `
      <div class="text-sm font-medium">${item.name}</div>
      <div class="text-xs text-gray-500">${item.dimensions.width}×${item.dimensions.depth}cm</div>
    `;
    document.body.appendChild(dragImage);
    e.dataTransfer.setDragImage(dragImage, 0, 0);
    
    // Usuwamy element z DOM po chwili (wymagane dla setDragImage)
    setTimeout(() => {
      document.body.removeChild(dragImage);
    }, 0);
  };

  const handleDragEnd = () => {
    setIsDragging(null);
  };

  return (
    <div className="absolute left-20 bottom-4 w-80 bg-white rounded-xl shadow-lg border border-gray-200 flex flex-col overflow-hidden z-10" style={{ maxHeight: 'calc(100vh - 100px)' }}>
      {/* Header */}
      <div className="bg-gray-50 px-4 py-3 border-b border-gray-200 flex items-center gap-2">
        <SafeIcon icon={FiTrendingUp} className="text-[#1E2937] text-lg" />
        <h3 className="font-semibold text-gray-700 text-sm">Katalog Schodów</h3>
      </div>

      {/* Items List */}
      <div className="flex-1 overflow-y-auto h-auto p-3 grid grid-cols-2 gap-2">
        {items.map((item) => (
          <div 
            key={item.id}
            draggable
            onDragStart={(e) => handleDragStart(e, item)}
            onDragEnd={handleDragEnd}
            className={clsx(
              "p-3 border-2 rounded-lg cursor-pointer transition-all hover:shadow-md flex flex-col items-center text-center gap-2",
              isDragging?.id === item.id 
                ? "border-[#1E2937] bg-gray-100 scale-95 opacity-50" 
                : "border-gray-200 hover:border-gray-300 bg-white"
            )}
          >
            <div className="text-2xl">{item.thumbnail}</div>
            <div className="flex flex-col w-full">
              <div className="text-xs font-medium text-gray-900 line-clamp-2">
                {item.name}
              </div>
              <div className="text-[10px] text-gray-500 mt-0.5">
                {item.dimensions.width}×{item.dimensions.depth}cm
              </div>
            </div>
          </div>
        ))}
      </div>

      {/* Footer Info */}
      <div className="bg-gray-50 px-4 py-2 border-t border-gray-200">
        <div className="text-[10px] text-gray-500 text-center">
          Przeciągnij schody na rzut
        </div>
      </div>
    </div>
  );
};

export default StairsCatalogPanel;